import { CATALOGUE_ROUTES } from "@constants"
import { commonFiltersShareValue, encodeCommonFiltersShareValue } from "@signals"


export default function useCatalogueAnalyzerGroupedVsSiteNavigation(dataRow) {
	const specificFilters = {
		brand: dataRow?.groupedID,
		country: dataRow?.country
	}

	return {
		urlDetails: `${CATALOGUE_ROUTES.DETAILS_PATH}?sp=${encodeCommonFiltersShareValue({...commonFiltersShareValue.peek(), ...specificFilters})}`
	}
}